/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Glue code for linking an inline uploader and the cropper to a form
//
// This manages changing state and resetting the cropper as needed.

namespace('Slzr.UI.PhotoUploader', function(exports, top) {
  let jQuery;
  const $ = (jQuery = Slzr.jQuery);

  return (function() {
    const Cls = (exports.Manager = class Manager {
      static initClass() {
        this.prototype.default_options = {
          // Prefix for crop offset elements
          cropPrefix: null,
  
          // Input selector for upload element
          uploadInput: null,
  
          // Element for transmitting photo state back to server
          stateInput: null,
  
          // Container for the action buttons
          actionButtonContainer: null,
  
          // Element to place cropper in
          cropContainer: null,
  
          // Crop aspect ratio ([width, height])
          cropAspect: [200, 150],
  
          // Legacy input, will be hidden if on supported browser (IE8+)
          legacyInput: null
        };
      }

      // Initialize this photo manager
      //
      // The element should be some wrapper with various child elements tagged with data-photo values:
      //
      // crop-x, crop-y, crop-w, crop-h: crop value hidden fields
      // key: hidden field for communicating photo state back to server
      // current: container for current photo + cropper (if available)
      // placeholder: container for placeholder photo
      // status: upload status display
      // menu-button: button for activating modify menu
      // menu-items: modify menu popup itself
      // upload: file input for uploading photos
      constructor(element, options) {
        this.disableCropper = this.disableCropper.bind(this);
        this.enableCropper = this.enableCropper.bind(this);
        this.destroyCropper = this.destroyCropper.bind(this);
        this.cropChanged = this.cropChanged.bind(this);
        this.createCropper = this.createCropper.bind(this);
        this.updateImage = this.updateImage.bind(this);
        this.clearPhoto = this.clearPhoto.bind(this);
        this.uploadDone = this.uploadDone.bind(this);
        this.uploadFail = this.uploadFail.bind(this);
        this.uploadDragOver = this.uploadDragOver.bind(this);
        this.uploadDragLeave = this.uploadDragLeave.bind(this);
        this._initializeUpload = this._initializeUpload.bind(this);
        this._initializeCropper = this._initializeCropper.bind(this);
        this._initializeActionButtons = this._initializeActionButtons.bind(this);
        this._showActionButtons = this._showActionButtons.bind(this);
        this._hideActionButtons = this._hideActionButtons.bind(this);
        this._handleUploadItemMove = this._handleUploadItemMove.bind(this);
        this._handleActionButtonClick = this._handleActionButtonClick.bind(this);
        this._updateActionButtonState = this._updateActionButtonState.bind(this);
        this.options = $.extend({}, this.default_options, options);

        this.crop_width = this.options.cropAspect[0];
        this.crop_height = this.options.cropAspect[1];

        // Extract elements
        this.crop_container          = $(element);
        this.upload_input            = this.crop_container.find('[data-photo="upload-input"]');
        this.state_input             = this.crop_container.find('[data-photo="key"]');
        this.current_container       = this.crop_container.find('[data-photo="current"]');
        this.placeholder_container   = this.crop_container.find('[data-photo="placeholder"]');
        this.action_button_container = this.crop_container.find('[data-photo="actions"]');
        this.status                  = this.crop_container.find('[data-photo="status"]');
        this.legacy_input            = $(this.options.legacyInput);
        if (options.disableDocumentDrop) { this.drop_zone               = this.crop_container; }
        if (this.current_container.find('[data-has-image="true"]').length > 0) { this.current_image           = {}; }
        this.allow_cropping          = this.current_container.data('photo-allow-crop');

        this._initializeCropper();

        // Don't initialize the menu and inline uploads on IE 7 and older,
        // to work around browser crashes
        if ((this.legacy_input.length === 0) || !(Slzr.Browser.IE && (Slzr.Browser.version < 8))) {
          this._initializeUpload();
          this._initializeActionButtons();
          this.legacy_input.hide();

          // Find any containing LABELs and disable clicks on it
          this.crop_container.closest('label').attr('for', '_unused_');
        } else {
          this.legacy_input.show();
        }
      }


      // Disable cropper
      disableCropper() {
        return (this.cropper != null ? this.cropper.disable() : undefined);
      }

      // Enable cropper
      enableCropper() {
        return (this.cropper != null ? this.cropper.enable() : undefined);
      }

      // Remove cropper element and image
      destroyCropper() {
        if (this.cropper != null) {
          this.cropper.destroy();
        }
        this.cropper = null;
        return this.current_image = null;
      }

      // Crop changed callback
      cropChanged(c) {
        this.crop_container.find('[data-photo="crop-x"]').val(c.x);
        this.crop_container.find('[data-photo="crop-y"]').val(c.y);
        this.crop_container.find('[data-photo="crop-w"]').val(c.w);
        return this.crop_container.find('[data-photo="crop-h"]').val(c.h);
      }

      // Create cropper element
      createCropper(el, options) {
        // Calculate minimum crop size, and scale into image dimensions
        // if the image is smaller.
        if (options == null) { options = {}; }
        const crop_aspect = this.crop_width / this.crop_height;
        const image_aspect = options.width / options.height;

        let min_crop_width = this.crop_width;
        let min_crop_height = this.crop_height;

        if (image_aspect < crop_aspect) {
          // Portrait
          if (options.width < this.crop_width) {
            min_crop_width = options.width;
            min_crop_height = options.width / crop_aspect;
          }

        } else if (image_aspect > crop_aspect) {
          // Landscape
          if (options.height < this.crop_height) {
            min_crop_height = options.height;
            min_crop_width = options.height * crop_aspect;
          }
        }

        const crop_options = {
          cropChanged: this.cropChanged,
          cropWidth:   min_crop_width,
          cropHeight:  min_crop_height,
          initialCrop: options.initial_crop,
          width:       options.width,
          height:      options.height
        };

        return this.cropper = new Slzr.UI.PhotoUploader.Cropper(el, crop_options);
      }

      // Update image using the hash returned from upload API
      updateImage(data) {
        let initial_crop;
        this.destroyCropper();
        this.current_image = data;

        // Calculate display dimensions; width 300, height whatever
        let display_w = data.metadata.width >= 300 ?
          300
        :
          data.metadata.width;

        let display_h = display_w / data.metadata.aspect_ratio;

        // Set image tag
        display_w = Math.floor(display_w);
        display_h = Math.floor(display_h);

        const img_attrs = {
          src: data.url,
          width: Math.floor(display_w),
          height: Math.floor(display_h)
        };

        // Update the img tag with the new image and sizing
        const img_tag = this.current_container.find('img');
        img_tag.attr(img_attrs);
        img_tag.css({width: `${display_w}px`, height: `${display_h}px`, maxWidth: 'none', maxHeight: 'none'});

        this.current_container.show();
        this.placeholder_container.hide();

        if (data.crop) {
          initial_crop = [data.crop.x, data.crop.y, data.crop.x + data.crop.w, data.crop.y + data.crop.h];
        } else {
          initial_crop = false;
        }

        if (this.allow_cropping) {
          this.createCropper(img_tag, {
            width: data.metadata.width,
            height: data.metadata.height,
            initial_crop
          }
          );
        }

        this.state_input.val(data.token);
        this.crop_container.trigger('slzr:photo:change');
        return this._updateActionButtonState();
      }

      // Clear uploaded photo and state
      clearPhoto() {
        this.destroyCropper();
        this.current_container.find('img').css({width: '', height: ''});
        this.state_input.val('deleted');
        $(`#${  this.options.cropPrefix  }_x`).val('');
        $(`#${  this.options.cropPrefix  }_y`).val('');
        $(`#${  this.options.cropPrefix  }_w`).val('');
        $(`#${  this.options.cropPrefix  }_h`).val('');

        this.current_image = null;
        this.current_container.hide();
        this.placeholder_container.show();
        this.crop_container.trigger('slzr:photo:remove');
        return this._updateActionButtonState();
      }

      // Upload done event handler
      uploadDone(event, data) {
        const {
          result
        } = data;
        if ((result != null ? result.status : undefined) === 'ok') {
          this.updateImage(data.result);
        }

        return this.upload_input = this.action_button_container.find('[data-photo="upload-input"]');
      }

      uploadFail(event, data) {}
        // console?.error('upload failed', event, data)

      uploadDragOver(event) {
        if ((event.srcElement != null ? event.srcElement.id : undefined) === 'zenbox_tab') { return true; }

        if (!this.upload_layer_shown) {
          if (!this.upload_layer) {
            this.upload_layer = $('<div>', {class: 'drop-image'}).html('DROP IMAGE NOW');
            $(document.body).append(this.upload_layer);
          }

          // Calculate font size for text
          // 385px width = 30px size
          // 960px width = 100px size

          const scaler = ($(window).width() - 385) / 575; // 960-385
          let new_font_size = (70 * scaler) + 30;

          // Clamp font size to 30-100px
          new_font_size = Math.max(new_font_size, 30);
          new_font_size = Math.min(new_font_size, 100);

          this.upload_layer.css({fontSize: `${new_font_size}px`});
          this.upload_layer.show();
          this.upload_layer_shown = true;
        }

        return true;
      }

      uploadDragLeave(event) {
        if ((event.type === 'dragleave') && (event.target !== (this.upload_layer != null ? this.upload_layer[0] : undefined))) { return true; }

        if (this.upload_layer_shown) {
          this.upload_layer.hide();
          this.upload_layer_shown = false;
        }

        return true;
      }

      // Initialize the inline uploader
      _initializeUpload() {
        this.uploader = new Slzr.UI.PhotoUploader.Input(this.upload_input, {statusElement: this.status, dropZone: this.drop_zone});

        this.upload_layer_shown = false;

        this.uploader.bind('fileuploaddone', this.uploadDone);
        this.uploader.bind('fileuploadfail', this.uploadFail);

        this.uploader.bind('fileuploaddragover', this.uploadDragOver);
        this.uploader.bind('fileuploaddrop', this.uploadDragLeave);
        return $(document).on('dragleave', this.uploadDragLeave);
      }

      // Initialize the cropper if there's an img with data-auto-crop=true in cropContainer
      //
      // The img needs to have data tags for crop-x/y/w/h for initial crop and original-width and original-height
      _initializeCropper() {
        const img = this.crop_container.find('img[data-auto-crop]');
        if (img.length > 0) {
          this.current_image = {};

          this.element = img;

          const img_w = img.data('original-width');
          const img_h = img.data('original-height');

          const crop_x = img.data('crop-x');
          const crop_y = img.data('crop-y');
          const crop_w = img.data('crop-w');
          const crop_h = img.data('crop-h');

          const initial_crop = (crop_x != null) && (crop_y != null) && (crop_w != null) && (crop_h != null) ?
            [crop_x, crop_y, crop_x + crop_w, crop_y + crop_h]
          :
            null;

          return this.createCropper(img, {
            initial_crop,
            width: img_w,
            height: img_h
          }
          );
        }
      }

      // Initialize the action menu
      _initializeActionButtons() {
        // Attach listeners for menu item actions
        this.action_button_container.on('click.photomanager', 'a[data-photo-action]', this._handleActionButtonClick);

        // Attach movement listener for the file input, and make sure the event data is the file input itself
        const self = this; // the Manager object, the event handler also needs to know the jquery "this" for the event target
        this.action_button_container.on('mousemove.photomanager mouseleave.photomanager', '[data-photo-action="upload-photo"]', function(ev) {
          return self._handleUploadItemMove(ev, this);
        });

        // Attach hover thing to image
        this.crop_container.on('mouseenter.photomanager', 'img, div', this._showActionButtons);
        this.crop_container.on('mouseleave.photomanager', 'img, div', this._hideActionButtons);
        this._updateActionButtonState();

        if (this.current_image) { return this._hideActionButtons(); }
      }

      _showActionButtons(ev) {
        return this.action_button_container.show();
      }

      _hideActionButtons(ev) {
        // Buttons are always visible when placeholder is shown
        if (this.current_image) { return this.action_button_container.hide(); }
      }

      // Move the upload input so the button stays under cursor
      //
      // IE especially needs the button clicked, not the text part
      //
      // ev is the event object; item is the link for uploading
      _handleUploadItemMove(ev, item) {
        item = $(item);

        // Only move if we're in the link's area, otherwise snap back and treat as a leave
        const in_link_area = (() => {
          if (ev.type === 'mousemove') {
          const link_pos = item.offset();

          const x1 = link_pos.left;
          const x2 = x1 + item.width();
          const y1 = link_pos.top;
          const y2 = y1 + item.height();

          return (x1 <= ev.pageX && ev.pageX <= x2) && (y1 <= ev.pageY && ev.pageY <= y2);
        } 
          return false;
        
        })();

        if (in_link_area) {
          // Make sure the button on the right is under the mouse cursor
          this.upload_input.position({
            my: 'right+30 center',
            at: 'right center',
            of: ev,
            collision: 'none'
          });
        } else {
          // Reset position
          this.upload_input.position({
            my: 'right top',
            at: 'right top',
            of: item,
            collision: 'none'
          });
        }

        return true;
      }

      // Handle a menu item click in the edit menu
      _handleActionButtonClick(ev) {
        const action = $(ev.target).data('photo-action');

        switch (action) {
          // Upload a new photo
          //
          // This really needs to be handled by an invisible file input above the menu item
          case 'upload-photo':
            true;
            break;

          // Choose an existing photo from the library, using photopop
          case 'choose-existing-photo':
            window.open('/admin/photos/photo_popup', 'photopop', 'width=550,height=350,scrollbars=yes');
            break;

          // Remove currently set photo
          case 'remove-photo':
            this.clearPhoto();
            break;

          default:
            if (typeof console !== 'undefined' && console !== null) {
              console.error('Unknown photo menu action:', action);
            }
        }

        return ev.preventDefault();
      }

      // Resize menu button to match the width of the displayed image
      _updateActionButtonState() {
        let width;
        if (this.current_image) {
          this.action_button_container.find('[data-photo-action="remove-photo"]').show();
          width = this.current_container.find('img').width();
        } else {
          this.action_button_container.find('[data-photo-action="remove-photo"]').hide();
          width = this.placeholder_container.find('img').width();
        }

        // button has 20px inset on each side from image
        return this.action_button_container.width(width);
      }
    });
    Cls.initClass();
    return Cls;
  }());
});
